module.exports = __webpack_public_path__ + "static/img/logo_tf88.32f9b226.png";